import * as types from '../../actions/types';

const initialState = {
  pageCount: 0,
  data: null
}

export default function teachers (state = initialState, action) {
  switch (action.type) {
    case types.SET_REVIEWS_TEACHERS:
      return {
        ...state, 
        data: action.payload,
        pageCount: action.pageCount
      }
    default:
      return state;
  }
}
